import React, { useEffect } from "react";
import styled from "styled-components";
import Gettext from "../common/Gettext";
import { fontSize } from "../common/styled-mixins";

import { gaReducer } from "../GA";
import { TradeThemeProvider } from "../ThemeProvider";
import CloseIcon from "../Icons/Close";

import mobileDarkImg1 from "../../images/earlySalePopup/earlySalePopupDarkImg1.png";
import mobileDarkImg2 from "../../images/earlySalePopup/earlySalePopupDarkImg2.png";
import desktopDarkImg1_en from "../../images/earlySalePopup/en_d.png";
import desktopDarkImg1_hi from "../../images/earlySalePopup/hi_d.png";
import desktopDarkImg1_id from "../../images/earlySalePopup/id_d.png";
import desktopDarkImg1_ph from "../../images/earlySalePopup/ph_d.png";
import desktopDarkImg1_th from "../../images/earlySalePopup/th_d.png";
import desktopDarkImg1_vn from "../../images/earlySalePopup/vn_d.png";
import desktopDarkImg2 from "../../images/earlySalePopup/earlySalePopupDarkDesktopImg2.png";

import mobileLightImg1 from "../../images/earlySalePopup/earlySalePopupLightImg1.png";
import mobileLightImg2 from "../../images/earlySalePopup/earlySalePopupLightImg2.png";
import desktopLightImg1_en from "../../images/earlySalePopup/en_l.png";
import desktopLightImg1_hi from "../../images/earlySalePopup/hi_l.png";
import desktopLightImg1_id from "../../images/earlySalePopup/id_l.png";
import desktopLightImg1_ph from "../../images/earlySalePopup/ph_l.png";
import desktopLightImg1_th from "../../images/earlySalePopup/th_l.png";
import desktopLightImg1_vn from "../../images/earlySalePopup/vn_l.png";
import desktopLightImg2 from "../../images/earlySalePopup/earlySalePopupLightDesktopImg2.png";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 20003;
`;

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 740px;
  padding: 40px 35px 32px;
  color: ${({ theme }) => (theme.mode === "light" ? "#919191" : "#CCCCCC")};
  background-color: ${({ theme }) =>
    theme.mode === "light" ? "#F5F5F5" : "#272B34"};
  border-radius: 4px;
  text-align: center;

  @media (max-width: 959px) {
    top: 0;
    left: 0;
    transform: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 32px 16px 38px;
    border-radius: 0;
  }
  @media (max-height: 500px) { 
    display: block;
    overflow-y: auto;
    position: relative;
    padding-top: 50px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 19px;
  right: 19px;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
  color: #717171;
  background: transparent;
  border: none;
  cursor: pointer;
`;

const Title = styled.div`
  margin-bottom: 21px;
  font-size: 28px;
  line-height: 1.2;
  color: ${({ theme }) => (theme.mode === "light" ? "#343434" : "#ffffff")};
  font-weight: 700;

  @media (max-width: 959px) {
    font-size: ${fontSize(18)};
    margin-bottom: 17px;
    font-weight: 500;
  }
`;

const Text = styled.div`
  font-size: ${fontSize(14)};
  line-height: 1.5;
  color: ${({ theme }) => (theme.mode === "light" ? "#919191" : "#CCCCCC")};
  margin-bottom: 37px;
  display: ${props => (props.mobile ? "none" : "block")};

  @media (max-width: 959px) {
    display: ${props => (props.mobile ? "block" : "none")};
    font-size: ${fontSize(14)};
    margin-bottom: 0;
  }
`;

const Img1 = styled.div`
  flex: 0 0 auto;
  width: 258px;
  height: 89px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 auto 14px;
  background-image: url(${({ images, theme }) =>
    theme.mode === "light" ? images.desktopLight : images.desktopDark});

  @media (max-width: 959px) {
    background-image: url(${({ images, theme }) =>
      theme.mode === "light" ? images.mobileLight : images.mobileDark});
  }
`;
const Img2 = styled.div`
  flex: 0 0 auto;
  width: 203px;
  height: 64px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 0 auto 30px;
  background-image: url(${({ images, theme }) =>
    theme.mode === "light" ? images.desktopLight : images.desktopDark});
  @media (max-width: 959px) {
    width: 304px;
    height: 109px;
    background-image: url(${({ images, theme }) =>
      theme.mode === "light" ? images.mobileLight : images.mobileDark});
  }
`;

const ButtonBlock = styled.div`
  display: flex;
  justify-content: center;
`;

const Button = styled.button`
  position: relative;
  min-width: 140px;
  padding: 12px 36px;
  font-weight: bold;
  font-size: ${fontSize(12)};
  color: #ffffff;
  text-decoration: none;
  text-transform: uppercase;
  background-image: linear-gradient(to right, #47c0c8 0%, #5c6cc0 100%);
  border: none;
  border-radius: 32px;
  cursor: pointer;
  z-index: 2;

  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: block;
    background-image: linear-gradient(to right, #5c6cc0 0%, #47c0c8 100%);
    border-radius: inherit;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.5s;
  }

  :hover::before {
    opacity: 1;
  }
`;

const closePopupHandler = (userId) => {
  return () => {
    try {
      localStorage.setItem(`${userId}:earlyClosePopup`, JSON.stringify(true));
    } catch (e) {}
  }
};

const EarlySalePopup = props => {
  useEffect(() => {
    gaReducer("EARLY_SALE_POPUP_SHOW");
  }, []);

  const desktopLightImg1 = (() => {
    switch (props.lang) {
      default:
      case "en":
        return desktopLightImg1_en;
      case "hi":
        return desktopLightImg1_hi;
      case "id":
        return desktopLightImg1_id;
      case "ph":
        return desktopLightImg1_ph;
      case "th":
        return desktopLightImg1_th;
      case "vn":
        return desktopLightImg1_vn;
    }
  })();

  const desktopDarkImg1 = (() => {
    switch (props.lang) {
      default:
      case "en":
        return desktopDarkImg1_en;
      case "hi":
        return desktopDarkImg1_hi;
      case "id":
        return desktopDarkImg1_id;
      case "ph":
        return desktopDarkImg1_ph;
      case "th":
        return desktopDarkImg1_th;
      case "vn":
        return desktopDarkImg1_vn;
    }
  })();

  return (
    <TradeThemeProvider>
    <Wrapper>
      <Overlay />
      <Container>
        <CloseButton onClick={() => props.onDismiss({ callback: closePopupHandler(props.userId) })}>
          <CloseIcon />
        </CloseButton>
        <Title>
          <Gettext>Try a new feature of the early closure.</Gettext>
          <br />
          <Gettext>
            Now you can close your trade earlier than the expiration time.
          </Gettext>
        </Title>

        <Img1
          images={{
            desktopLight: desktopLightImg1,
            desktopDark: desktopDarkImg1,
            mobileLight: mobileLightImg1,
            mobileDark: mobileDarkImg1
          }}
        />

        <Text mobile>
          <Gettext>
            Click on the cross to open trades list and choose the one to close
            earlier. Please note that the cross is active only when the trade is
            possible to be closed earlier.
          </Gettext>
        </Text>

        <Text>
          <Gettext>
            Close your trades with a button on a price chart, or in the opened
            trades list. Please note that the close button is active only when
            the trade is possible to be closed earlier.
          </Gettext>
        </Text>

        <Img2
          images={{
            desktopLight: desktopLightImg2,
            desktopDark: desktopDarkImg2,
            mobileLight: mobileLightImg2,
            mobileDark: mobileDarkImg2
          }}
        />

        <ButtonBlock>
          <Button onClick={() => props.onDismiss({ callback: closePopupHandler(props.userId) })}>
            <Gettext>Got it</Gettext>
          </Button>
        </ButtonBlock>
      </Container>
    </Wrapper>
    </TradeThemeProvider>
  );
};

export default EarlySalePopup;



// WEBPACK FOOTER //
// ./src/components/TradeModals/EarlySalePopup.js